import React, { Component } from 'react';
import imageTop from './img/top_img_header.png';
import imageButtonStart from './img/btn01.png';
import imageButtonOthers from './img/btn02.png';
import imageFooter from './img/top_img_footer.png';
import './view.css';

class ViewStart extends Component {
    render() {
        return (
            <div className="container">
                <div>
                    <img src={imageTop} id="start"></img>
                </div>
                <div className="buttons">
                    <div onClick={this.props.onClickStart}>
                        <img src={imageButtonStart} id="start"></img>
                    </div>
                    <div onClick={this.props.onClickOthers}>
                        <img src={imageButtonOthers} id="other"></img>
                    </div>
                </div>
                <footer>
                    <img src={imageFooter}></img>
                </footer>
            </div>
        );
    }
}

export default ViewStart;
